import 'slick-carousel';
var dogAdotion = {};

(function (dogAdotionApp) {
	var filterModel = {
		//Page: 1,
		Age: "",
		Size: "",
		GoodWith: "",
		Gender: "",
		EnergyType: "",
		Location: "",
		Name: ""
	};
	var fromPopState = false;
	var blockPopstateEvent = true;
	var browserSupportsHistoryApi = window.history && 'pushState' in window.history;

	if (browserSupportsHistoryApi) {
		// prevent Chrome from calling onpopstate on initial load
		$(window).on('load', function () {
			// The timeout ensures that popstate-events will be unblocked right
			// after the load event occured, but not in the same event-loop cycle.
			setTimeout(function () { blockPopstateEvent = false; }, 0);
		});

		$(window).on('popstate', function () {
			if (blockPopstateEvent && document.readyState === "complete") {
				return;
			}
			fromPopState = true;
			performSearchFromUrl();
		});
	}

	function pushHistory() {
		if (browserSupportsHistoryApi && !fromPopState) {
			var currentPath = window.location.pathname;
			var query = "?";
			var queryArray = [];

			//if (filterModel.Page) {
			//    queryArray.push("page=" + filterModel.Page);
			//}
			if (filterModel.Age) {
				queryArray.push("age=" + filterModel.Age);
			}
			if (filterModel.Size) {
				queryArray.push("size=" + filterModel.Size);
			}
			if (filterModel.GoodWith) {
				queryArray.push("goodwith=" + filterModel.GoodWith);
			}
			if (filterModel.Gender) {
				queryArray.push("gender=" + filterModel.Gender);
			}
			if (filterModel.EnergyType) {
				queryArray.push("energytype=" + filterModel.EnergyType);
			}
			if (filterModel.Location) {
				queryArray.push("location=" + filterModel.Location);
			}
			if (filterModel.Name) {
				queryArray.push("name=" + filterModel.Name);
			}
			query += queryArray.join("&");
			history.pushState(null, null, currentPath + query);
		}
		fromPopState = false;
	}

	function performSearchFromUrl() {
		dogAdotionApp.InitializeFilterModel();

		if (window.location.search.length > 1) {
			for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
				nKeyId < aCouples.length;
				nKeyId++) {
				aItKey = aCouples[nKeyId].split("=");
				if (aItKey.length <= 1)
					continue;
				var key = decodeURIComponent(aItKey[0]).toLowerCase();
				var val = decodeURIComponent(aItKey[1]);

				//if (key === "page") {
				//    filterModel.Page = val;
				//} else
				if (key === "age") {
					filterModel.Age = val;
				} else if (key === "size") {
					filterModel.Size = val;
				} else if (key === "goodwith") {
					filterModel.GoodWith = val;
				} else if (key === "gender") {
					filterModel.Gender = val;
				} else if (key === "energytype") {
					filterModel.EnergyType = val;
				} else if (key === "location") {
					filterModel.Location = val;
				} else if (key === "name") {
					filterModel.Name = val;
				}
			}
		}
		dogAdotionApp.SetInputValue();
		dogAdotionApp.GetSearchResults();
	}

	dogAdotionApp.SetInputValue = function () {
		$('#dog-adoption-search-form input:checkbox').each(function () {
			$(this).prop('checked', false);
		});

		let dogSizes = filterModel.Size.split(",");
		if (dogSizes) {
			dogSizes.forEach(function (dogSize) {
				if (dogSize != "") {
					$(`.js-dog-size input[type="checkbox"][value="${dogSize}"]`).prop('checked', true);
				}
			});
		}

		let goodwiths = filterModel.GoodWith.split(",");
		if (goodwiths) {
			goodwiths.forEach(function (goodwith) {
				if (goodwith != "") {
					$(`.js-dog-goodwith input[type="checkbox"][value="${goodwith}"]`).prop('checked', true);
				}
			});
		}

		let genders = filterModel.Gender.split(",");
		if (genders) {
			genders.forEach(function (gender) {
				if (gender != "") {
					$(`.js-dog-gender input[type="checkbox"][value="${gender}"]`).prop('checked', true);
				}
			});
		}

		let energytypes = filterModel.EnergyType.split(",");
		if (energytypes) {
			energytypes.forEach(function (energytype) {
				if (energytype != "") {
					$(`.js-dog-energytype input[type="checkbox"][value="${energytype}"]`).prop('checked', true);
				}
			});
		}

		let ages = filterModel.Age.split(",");
		if (ages) {
			ages.forEach(function (age) {
				if (age != "") {
					$(`.js-dog-age input[type="checkbox"][value="${age}"]`).prop('checked', true);
				}
			});
		}

		$('.js-dog-name').val(filterModel.Name);
		$('.js-dog-location').val(filterModel.Location);
	};

	dogAdotionApp.GetSearchResults = function () {
		$.ajax({
			url: "/umbraco/surface/DogAdoptionSurface/GetSearchResults",
			data: filterModel,
			type: 'POST',
			cache: false,
			dataType: "html",
			success: function (data) {
				$('.js-dog-adoption-section').html($(data));
				dogAdotionApp.InitializeSlider();
				dogAdotionApp.SetCount();
				pushHistory();
			},
			error: function (XMLHttpRequest, textStatus, errorThrown) {
				console.log(XMLHttpRequest.Status);
				console.log(textStatus);
				console.log(errorThrown);
			}
		});
	}

	dogAdotionApp.SetCount = function () {
		let filtercount = $('.js-dog-adoption-wrapper').data('filtercount');
		let filtereditemcount = $('.js-dog-adoption-wrapper').data('filtereditemcount');

		$('.js-filtercount').text(filtercount);
		$('.js-filtereditemcount').text(filtereditemcount);
	}

	dogAdotionApp.InitializeFilterModel = function () {
		//filterModel.Page = 1;
		filterModel.Age = "";
		filterModel.Size = "";
		filterModel.GoodWith = "";
		filterModel.Gender = "";
		filterModel.EnergyType = "";
		filterModel.Location = "";
		filterModel.Name = "";
	}

	dogAdotionApp.InitializeSlider = function () {
		$('.image-slider').slick({
			adaptiveHeight: true,
			fade: true,
			arrows: true,
			dots: false,
			prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Prev</span> <svg class="icon" role="presentation"><use xlink:href="#icon-arrow-left"></use></svg></button>',
			nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next</span> <svg class="icon" role="presentation"><use xlink:href="#icon-arrow-right"></use></svg></button>'
		});
	}

	$(document).ready(function () {
		//check if querystring params exist on load/reload
		const urlParams = new URLSearchParams(window.location.search);

		if (urlParams.get('age')) {
			filterModel.Age = urlParams.get('age');
		}
		if (urlParams.get('size')) {
			filterModel.Size = urlParams.get('size');
		}
		if (urlParams.get('goodwith')) {
			filterModel.GoodWith = urlParams.get('goodwith');
		}
		if (urlParams.get('gender')) {
			filterModel.Gender = urlParams.get('gender');
		}
		if (urlParams.get('energytype')) {
			filterModel.EnergyType = urlParams.get('energytype');
		}
		if (urlParams.get('location')) {
			filterModel.Location = urlParams.get('location');
		}
		if (urlParams.get('name')) {
			filterModel.Name = urlParams.get('name');
		}

		dogAdotionApp.SetCount();

		$(document).on("submit", "#dog-adoption-search-form", function (e) {
			e.preventDefault();
			getFilterValues()
			dogAdotionApp.GetSearchResults();
		});

		function getFilterValues() {
			let size = [];
			let goodwith = [];
			let gender = [];
			let energytype = [];
			let age = [];

			$('.js-dog-size :checked').each(function () {
				size.push($(this).val());
			});
			filterModel.Size = size.join(",");

			$('.js-dog-goodwith :checked').each(function () {
				goodwith.push($(this).val());
			});
			filterModel.GoodWith = goodwith.join(",");

			$('.js-dog-gender :checked').each(function () {
				gender.push($(this).val());
			});
			filterModel.Gender = gender.join(",");

			$('.js-dog-energytype :checked').each(function () {
				energytype.push($(this).val());
			});
			filterModel.EnergyType = energytype.join(",");

			$('.js-dog-age :checked').each(function () {
				age.push($(this).val());
			});
			filterModel.Age = age.join(",");

			filterModel.Name = $('.js-dog-name').val();
			filterModel.Location = $('.js-dog-location').val();
		}

		$(document).on("click", ".js-clear-all", function (e) {
			e.preventDefault();
			dogAdotionApp.InitializeFilterModel();
			dogAdotionApp.GetSearchResults();
			dogAdotionApp.SetInputValue()
		});


		//on pagination click event
		$(document).on('click', 'ul.pagination a', function (e) {
			e.preventDefault();
			filterModel.Page = $(this).data('page');
			setCookie();
			dogAdotionApp.GetSearchResults();
		});
	});

})(dogAdotion);
